import { combineReducers } from "redux";
import {
  BUSINESS_SERVICE_AREAS_CLEAR_ACTIVE,
  BUSINESS_SERVICE_AREAS_CREATE,
  BUSINESS_SERVICE_AREAS_GET_BY_ID,
  BUSINESS_SERVICE_AREAS_PATCH,
  BUSINESS_SERVICE_AREAS_SEARCH,
} from "../actions/businessServiceAreas";
import { publishActionToast } from "../services/toasts";

const successToasts = {
  [BUSINESS_SERVICE_AREAS_CREATE]: "Created business service area successfully",
  [BUSINESS_SERVICE_AREAS_PATCH]: "Updated business service area successfully",
};

const byId = (state = {}, action) => {
  publishActionToast(action, "BUSINESS_SERVICE_AREAS_", successToasts);

  switch (action.type) {
    case `${BUSINESS_SERVICE_AREAS_SEARCH}_SUCCESS`:
    case `${BUSINESS_SERVICE_AREAS_GET_BY_ID}_SUCCESS`:
    case `${BUSINESS_SERVICE_AREAS_CREATE}_SUCCESS`:
    case `${BUSINESS_SERVICE_AREAS_PATCH}_SUCCESS`:
      return {
        ...state,
        ...action.response.entities.businessServiceArea,
      };

    default:
      break;
  }

  return state;
};

const defaultActive = {
  dashboard: [],
  dashboardLastUpdate: 0,
  activeBusinessServiceArea: null,
  lastEdit: 0,
  error: null,
  pagination: {
    offset: 0,
    pageSize: 50,
    resultCount: 0,
  },
};

const active = (state = defaultActive, action) => {
  switch (action.type) {
    case BUSINESS_SERVICE_AREAS_CLEAR_ACTIVE:
      return {
        ...defaultActive,
      };

    case `${BUSINESS_SERVICE_AREAS_SEARCH}_SUCCESS`:
      return {
        ...state,
        dashboard: [...action.response.result],
        dashboardLastUpdate: new Date().getTime(),
        pagination: {
          ...action.response.pagination,
          pageSize: defaultActive.pagination.pageSize,
        },
      };

    case `${BUSINESS_SERVICE_AREAS_GET_BY_ID}_SUCCESS`:
      return {
        ...state,
        activeBusinessServiceArea: action.response.result,
      };

    case `${BUSINESS_SERVICE_AREAS_CREATE}_SUCCESS`:
    case `${BUSINESS_SERVICE_AREAS_PATCH}_SUCCESS`:
      return {
        ...state,
        activeBusinessServiceArea: action.response.result,
        lastEdit: new Date().getTime(),
      };

    default:
      break;
  }

  return state;
};

export default combineReducers({
  active,
  byId,
});

export const getActiveBusinessServiceArea = (state) =>
  state.active.activeBusinessServiceArea
    ? state.byId[state.active.activeBusinessServiceArea]
    : null;
export const getAll = (state) =>
  state.active.dashboard.map((id) => state.byId[id]);
export const getPagination = (state) => state.active.pagination;
export const getLastEdit = (state) => state.active.lastEdit;
